/**
 * @generated SignedSource<<c4f802c676d1255c27a814e14df57d08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
export type WebFormSubmissionsOrderByField = "completed_at" | "created_at" | "duration" | "score" | "user_name" | "%future added value";
export type WebFormSubmissionsOrderByInput = {
  direction: OrderDirection;
  field: WebFormSubmissionsOrderByField;
};
export type webFormSubmissionsUtils_usePaginatedSubmissionsQuery$variables = {
  after?: string | null;
  before?: string | null;
  completedAfter?: string | null;
  contentUsageId?: string | null;
  first?: number | null;
  include: boolean;
  isComplete?: boolean | null;
  isFailed?: boolean | null;
  isPassed?: boolean | null;
  last?: number | null;
  membersOnly?: boolean | null;
  orderBy?: WebFormSubmissionsOrderByInput | null;
  percentageGreaterThanOrEqual?: number | null;
  percentageLessThan?: number | null;
  revisionId: string;
  search?: string | null;
  submissionIds?: ReadonlyArray<string> | null;
};
export type webFormSubmissionsUtils_usePaginatedSubmissionsQuery$data = {
  readonly node?: {
    readonly __typename: "WebFormRevision";
    readonly id: string;
    readonly questions: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly answerKey: {
            readonly correctIds: ReadonlyArray<string>;
            readonly feedback: string | null;
          } | null;
          readonly id: string;
          readonly isRequired: boolean;
          readonly options: ReadonlyArray<{
            readonly id: string;
            readonly label: string;
          }> | null;
          readonly ordering: number;
          readonly richEditorBody: string;
          readonly type: WebFormQuestionType;
        };
      }>;
    };
    readonly webFormId: string;
    readonly " $fragmentSpreads": FragmentRefs<"webFormSubmissionsUtils_usePaginatedSubmissionsPaginationFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type webFormSubmissionsUtils_usePaginatedSubmissionsQuery = {
  response: webFormSubmissionsUtils_usePaginatedSubmissionsQuery$data;
  variables: webFormSubmissionsUtils_usePaginatedSubmissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "completedAfter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentUsageId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "include"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isComplete"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFailed"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPassed"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membersOnly"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "percentageGreaterThanOrEqual"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "percentageLessThan"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "revisionId"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "submissionIds"
},
v17 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "revisionId"
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webFormId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "correctIds",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "WebFormQuestionNodeConnection",
  "kind": "LinkedField",
  "name": "questions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WebFormQuestionNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WebFormQuestion",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ordering",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "richEditorBody",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRequired",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "WebFormQuestionOption",
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": [
                (v18/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "WebFormQuestionAnswerKey",
              "kind": "LinkedField",
              "name": "answerKey",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "feedback",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "completedAfter",
    "variableName": "completedAfter"
  },
  {
    "kind": "Variable",
    "name": "contentUsageId",
    "variableName": "contentUsageId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "isComplete",
    "variableName": "isComplete"
  },
  {
    "kind": "Variable",
    "name": "isFailed",
    "variableName": "isFailed"
  },
  {
    "kind": "Variable",
    "name": "isPassed",
    "variableName": "isPassed"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "membersOnly",
    "variableName": "membersOnly"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "percentageGreaterThanOrEqual",
    "variableName": "percentageGreaterThanOrEqual"
  },
  {
    "kind": "Variable",
    "name": "percentageLessThan",
    "variableName": "percentageLessThan"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "submissionIds",
    "variableName": "submissionIds"
  }
],
v24 = [
  (v18/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "webFormSubmissionsUtils_usePaginatedSubmissionsQuery",
    "selections": [
      {
        "condition": "include",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v17/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v22/*: any*/),
                  {
                    "args": (v23/*: any*/),
                    "kind": "FragmentSpread",
                    "name": "webFormSubmissionsUtils_usePaginatedSubmissionsPaginationFragment"
                  }
                ],
                "type": "WebFormRevision",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v14/*: any*/),
      (v3/*: any*/),
      (v16/*: any*/),
      (v5/*: any*/),
      (v11/*: any*/),
      (v15/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "webFormSubmissionsUtils_usePaginatedSubmissionsQuery",
    "selections": [
      {
        "condition": "include",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v17/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              (v18/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v20/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": (v23/*: any*/),
                    "concreteType": "WebFormSubmissionNodeConnection",
                    "kind": "LinkedField",
                    "name": "submissions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebFormSubmissionNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WebFormSubmission",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "webFormRevisionId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "completedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "durationSeconds",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasAnswerKey",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasPassed",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormAnswerNodeConnection",
                                "kind": "LinkedField",
                                "name": "answers",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WebFormAnswerNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "WebFormAnswer",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v18/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "body",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "selectedOptions",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "webFormQuestionId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isSkipped",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isCorrect",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WebFormAnswerResult",
                                            "kind": "LinkedField",
                                            "name": "result",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "incorrectSelections",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormSubmissionResult",
                                "kind": "LinkedField",
                                "name": "result",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "score",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "total",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "percentage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WebFormAnswer",
                                    "kind": "LinkedField",
                                    "name": "correctAnswers",
                                    "plural": true,
                                    "selections": (v24/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WebFormAnswer",
                                    "kind": "LinkedField",
                                    "name": "incorrectAnswers",
                                    "plural": true,
                                    "selections": (v24/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "fullName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "avatar",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isTest",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfoObjectType",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPreviousPage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startCursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__id",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v23/*: any*/),
                    "filters": [
                      "contentUsageId",
                      "submissionIds",
                      "orderBy",
                      "search",
                      "isComplete",
                      "completedAfter",
                      "percentageGreaterThanOrEqual",
                      "percentageLessThan",
                      "isPassed",
                      "isFailed",
                      "membersOnly"
                    ],
                    "handle": "connection",
                    "key": "webFormQueryUtils_admin_submissions",
                    "kind": "LinkedHandle",
                    "name": "submissions"
                  }
                ],
                "type": "WebFormRevision",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "da8d61bc5e2c794e6ea2f16c82fb12c7",
    "id": null,
    "metadata": {},
    "name": "webFormSubmissionsUtils_usePaginatedSubmissionsQuery",
    "operationKind": "query",
    "text": "query webFormSubmissionsUtils_usePaginatedSubmissionsQuery(\n  $revisionId: ID!\n  $contentUsageId: ID\n  $submissionIds: [ID!]\n  $include: Boolean!\n  $orderBy: WebFormSubmissionsOrderByInput\n  $search: String\n  $isComplete: Boolean\n  $completedAfter: DateTime\n  $percentageGreaterThanOrEqual: Float\n  $percentageLessThan: Float\n  $isPassed: Boolean\n  $isFailed: Boolean\n  $membersOnly: Boolean\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n) {\n  node(id: $revisionId) @include(if: $include) {\n    __typename\n    ... on WebFormRevision {\n      id\n      __typename\n      webFormId\n      questions {\n        edges {\n          node {\n            id\n            type\n            ordering\n            richEditorBody\n            isRequired\n            options {\n              id\n              label\n            }\n            answerKey {\n              correctIds\n              feedback\n            }\n          }\n        }\n      }\n      ...webFormSubmissionsUtils_usePaginatedSubmissionsPaginationFragment_2ZgQbl\n    }\n    id\n  }\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment webFormSubmissionsUtils_usePaginatedSubmissionsPaginationFragment_2ZgQbl on WebFormRevision {\n  submissions(contentUsageId: $contentUsageId, submissionIds: $submissionIds, orderBy: $orderBy, search: $search, isComplete: $isComplete, completedAfter: $completedAfter, percentageGreaterThanOrEqual: $percentageGreaterThanOrEqual, percentageLessThan: $percentageLessThan, isPassed: $isPassed, isFailed: $isFailed, membersOnly: $membersOnly, first: $first, after: $after, last: $last, before: $before) {\n    totalCount\n    edges {\n      node {\n        id\n        webFormId\n        webFormRevisionId\n        completedAt\n        durationSeconds\n        hasAnswerKey\n        hasPassed\n        answers {\n          edges {\n            node {\n              id\n              body\n              selectedOptions\n              webFormQuestionId\n              isSkipped\n              isCorrect\n              result {\n                correctIds\n                incorrectSelections\n              }\n            }\n          }\n        }\n        result {\n          score\n          total\n          percentage\n          correctAnswers {\n            id\n          }\n          incorrectAnswers {\n            id\n          }\n        }\n        user {\n          id\n          fullName\n          ...ProfileAvatarFragment\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "021e02a3857e1e56122a3e5852413839";

export default node;
